import React from 'react';

const EmptyDash = () => {
  return (
    <div className="empty-dash" role="none">
      <code>&#8212;&#8212;</code>
    </div>
  );
};

export default EmptyDash;
